import AddonsSegmentHeader from './addonsSegmentHeader'

const AddonsSegmentHeaderWrapper = ({
    segments,
    selectedSegmentIndex,
    setSelectedSegmentIndex
}: {
    segments: { from: string; to: string }[]
    selectedSegmentIndex: number
    setSelectedSegmentIndex: (index: number) => void
}) => {
    return (
        <AddonsSegmentHeader
            segments={segments}
            selectedSegmentIndex={selectedSegmentIndex}
            setSelectedSegmentIndex={setSelectedSegmentIndex}
        />
    )
}

export default AddonsSegmentHeaderWrapper
